import { SelectOption } from '../../../../components/Select';

export function isFreeText(option: SelectOption | null | undefined): boolean {
  if (!option) return false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Boolean((option as any).__isNew__);
}

export function shouldWarnHrisField(
  currentLabel: string | null | undefined,
  suggestionLabel: string | null,
  freeText: boolean,
  dirty: boolean,
): boolean {
  // Free text always warns regardless of dirty state — the typed value bypasses
  // the HRIS-validated dropdown.
  if (freeText) return true;
  // Once the user picks an option from the HRIS dropdown the field is dirty
  // and the selection is, by construction, a valid HRIS value — no warning.
  if (dirty) return false;
  // Untouched field: warn when the auto-populated value (or the Screenloop
  // fallback default) does not match the suggested HRIS value.
  return (currentLabel ?? '') !== (suggestionLabel ?? '');
}

export function hrisFieldWarningTooltip(args: {
  currentLabel: string | null | undefined;
  suggestionLabel: string | null;
  freeText: boolean;
  dirty: boolean;
  fieldLabel: string;
}): string | undefined {
  if (
    !shouldWarnHrisField(
      args.currentLabel,
      args.suggestionLabel,
      args.freeText,
      args.dirty,
    )
  ) {
    return undefined;
  }
  return `Selected ${args.fieldLabel} cannot be found in your HRIS. Verify values are an exact match, or export to HRIS may fail`;
}
